import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    cardGrid: { marginTop: 6 },
    cardsTitleModal: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 550,
    },
    switchGrid: { alignItems: 'center', display: 'flex', marginRight: '8px' },
    switchText: { fontSize: 12, fontWeight: 500, marginLeft: 2 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    previewModal: { display: 'flex', justifyContent: 'center' },
    cardPreview: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      width: 'max-content',
    },
    cardPreviewItem: {
      margin: 6,
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      padding: 8,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    closeIcon: {
      color: palette.red,
      fontSize: 20,
      cursor: 'pointer',
      marginRight: 2,
    },
    dragIcon: {
      color: palette.blue,
      fontSize: 20,
      cursor: 'grab',
      marginLeft: 2,
    },
    cardPreviewNoDash: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      padding: 8,
      alignItems: 'center',
    },
    noDashIcon: {
      color: palette.grey600,
      fontSize: 18,
      marginRight: 4,
    },
    optionsModal: { display: 'flex', justifyContent: 'flex-end' },
    cleanIcon: { color: palette.red, fontSize: 26, cursor: 'pointer' },
    cleanButton: {
      color: palette.red,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    cardSelector: {
      margin: 6,
      maxWidth: '32%',
      width: '32%',
      cursor: 'pointer',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    cardSelectorActive: {
      border: `1px solid ${palette.green}`,
      margin: 6,
      borderRadius: 4,
      maxWidth: '32%',
      width: '32%',
      backgroundColor: palette.lightGreen,
    },
    modalCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
    },
    modalCardHeaderCollapse: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
    },
    checkIconModal: { fontSize: 20, color: palette.green },
  });
